<div class="flex flex-col gap-3" data-testid="bibtex-form">
  <input
    #fileInput
    type="file"
    accept=".bib"
    class="hidden"
    (change)="onPick($event)"
    data-testid="bibtex-file-input"
  />

  <div
    class="flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed p-6 text-center transition-colors"
    [class.border-secondary]="dragOver()"
    [class.bg-slate-50]="dragOver()"
    [class.border-slate-300]="!dragOver()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    data-testid="bibtex-drop-zone"
  >
    <p class="text-sm text-gray-700">Drag a <span class="font-semibold">.bib</span> file here</p>
    <p class="text-xs text-gray-500">or</p>
    <button
      type="button"
      class="btn-small-secondary"
      (click)="fileInput.click()"
      data-testid="bibtex-pick-button"
    >
      Choose .bib file
    </button>
    <p class="text-xs text-gray-400">Max 100 MB</p>
  </div>

  @if (fileError(); as msg) {
    <p class="text-sm text-red-700" data-testid="bibtex-file-error">{{ msg }}</p>
  }

  @if (file(); as f) {
    <div
      class="flex items-center justify-between rounded-md bg-slate-50 p-2 text-sm"
      data-testid="bibtex-selected-file"
    >
      <span class="truncate" [attr.title]="f.name">{{ f.name }} — {{ formatSize(f.size) }}</span>
      <button
        type="button"
        class="ml-2 text-red-600 hover:text-red-700"
        (click)="clearFile()"
        aria-label="Remove file"
        data-testid="bibtex-remove-file"
      >
        ×
      </button>
    </div>
  }

  @if (submitError(); as msg) {
    <p class="text-sm text-red-700" data-testid="bibtex-submit-error">{{ msg }}</p>
  }

  <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
    <button
      type="button"
      class="btn-primary w-full sm:w-auto"
      [disabled]="!file() || submitting()"
      (click)="submit()"
      data-testid="bibtex-submit"
    >
      {{ submitting() ? 'Importing…' : 'Import BibTeX' }}
    </button>
  </div>
</div>
